import ClipboardJS from 'clipboard';

const initNode = (node) => {
  node.classList.add('clipboard_initialized');
  const clipboard = new ClipboardJS(node);

  clipboard.on('success', function(e) {
    node.classList.add('active');
    setTimeout(() => { node.classList.remove('active'); }, 500);
  });
};

const initAll = () => {
  const nodes = document.querySelectorAll('.clipboard:not(.clipboard_initialized)');
  Array.from(nodes).forEach(node => initNode(node));
};

const start = () => {
  document.addEventListener('page:load', initAll);
  document.addEventListener('ajax:success', initAll);
};

export default { initAll, start };
